export enum PuzzlePieceType {
  DEV_CENTER = "devday24",
  SESSIONS = "sessions",
  INFO = "info",
}

export type PuzzlePieceModel = {
  order: number;
  id: string;
  piece: string;
  isFound: boolean;
  type: PuzzlePieceType;
};

export type PuzzlePieceHintsModel = {
  id: string;
  hints: string[];
  video: { url: string; label: string };
};

export type PuzzleDictionary = {
  [index: string]: PuzzlePieceModel;
};

export type PuzzleHintsDictionary = {
  [index: string]: PuzzlePieceHintsModel;
};

export type PuzzleCard = {
  id: string;
  value: string;
  hints: string[];
  video: { url: string; label: string };
  type: PuzzlePieceType;
};

export type PuzzlePiecesBundle = {
  sitePieces: string[];
  eventPieces: string[];
};
